import { render } from "./leak-view-table.vue?vue&type=template&id=52dd7c78&scoped=true&ts=true"
import script from "./leak-view-table.vue?vue&type=script&lang=ts"
export * from "./leak-view-table.vue?vue&type=script&lang=ts"

import "./leak-view-table.vue?vue&type=style&index=0&id=52dd7c78&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dd7c78"]])

export default __exports__